import { cn } from "@/lib/utils";

/**
 * Zettl wordmark — Sora 700, tracking -0.04em, ink with brand-green period.
 *
 * Single source of truth for the brand mark. Use this anywhere the logo
 * appears: sidebars, auth pages, splash, loading states. For dark surfaces
 * pass `variant="onDark"` to flip the wordmark to paper while keeping the
 * green dot.
 */

type LogoSize = "xs" | "sm" | "md" | "lg" | "xl";

const sizeClasses: Record<LogoSize, string> = {
  xs: "text-base",
  sm: "text-lg",
  md: "text-2xl",
  lg: "text-4xl",
  xl: "text-6xl",
};

interface LogoProps {
  size?: LogoSize;
  variant?: "default" | "onDark";
  className?: string;
  /** Hide the period mark — rare, only when paired with a separate badge */
  noDot?: boolean;
}

export function Logo({ size = "md", variant = "default", className, noDot = false }: LogoProps) {
  return (
    <span
      aria-label="Zettl"
      className={cn(
        "select-none font-logo font-bold leading-none tracking-[-0.04em]",
        sizeClasses[size],
        variant === "onDark" ? "text-paper" : "text-ink dark:text-paper",
        className
      )}
    >
      Zettl{!noDot && <span className="text-brand-green">.</span>}
    </span>
  );
}
